export const isMatchPropertyOptionCondition = (
  condition,
  properties,
) => {
  const [propertyId, optionId] = condition.split('/');

  if (optionId === 'unselected') {
    return !properties?.[propertyId]?.length;
  }

  if (propertyId === 'ticketType') {
    return properties?.[propertyId]?.includes(optionId);
  }

  if (Array.isArray(optionId)) {
    return optionId.includes(properties?.[propertyId]);
  }

  return properties?.[propertyId]?.includes(optionId);
};

export const isMatchPropertyOptionConditions = (conditions, properties) => {
  return (conditions || []).some((condition) => isMatchPropertyOptionCondition(condition, properties));
};
